import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useEffect, useState } from 'react'

import styled from 'styled-components'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { TimeCompare } from 'components/TimeCompare'
import { DataWrapperChart } from 'components/DataWrapperChart'
import { Link } from '@ta-interaktiv/contentbricks'
import { csvParse } from 'd3-dsv'

const isMobile = window.innerWidth < 800

const MainComponent: FC<MicroFrontendProps> = (props): ReactElement => {
  const [drawData, setDrawData] = useState()
  const [textValues, setTextValues] = useState({
    current7DayAveCases: 0,
    changeTo2Nov2020Cases: 0,
    currentHospRatio: 0,
  })
  
  
  
  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    console.log("gemeinde: ",params.get("gemeinde"));
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/corona-dashboard/dashboard-facts.json'
    )
      .then((response) => response.json())
      .then((data) => {})
  }, [])
  useEffect(() => {
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/timecompare/_all.csv'
    )
      .then((response) => response.text())
      .then((data) => {
        const parsed = csvParse(data)
        const dd:any = {}
        parsed.forEach((day) => {
          const date = day.d
          if (isMobile && new Date(date!) < new Date('2020-08-01')) {
            return
          }
          Object.entries(day).forEach(([code_type, value]) => {
            const code = code_type.split('_')[0]
            const type = code_type.split('_')[1]
            if (!dd[code]) dd[code] = {}
            if (!dd[code][type]) dd[code][type] = []
            dd[code][type].push({ d: date, v: +(value || '') })
          })
        })
        const chCases = dd.CH.cases
        const chRatio = dd.CH.hospRatio
        console.log(dd)
        setTextValues({
          current7DayAveCases: chCases[chCases.length - 1].v.toFixed(0),
          changeTo2Nov2020Cases: Math.round(
            (chCases[chCases.length - 1].v * 100) /
              chCases.find((f: any) => f.d === '2020-11-02').v -
              100
          ),
          currentHospRatio: chRatio[chRatio.length - 1].v,
        })
        setDrawData(dd)
      })
  }, [])
  return (
    <div className='index'>
      {/* <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>So heftig ist die fünfte Corona-Welle im Zeitvergleich</h1>
            <h2>
              Vergleichen Sie die aktuellen Fallzahlen mit dem Höhepunkt der
              zweiten, dritten und vierten Welle – oder wählen Sie jeden
              beliebigen Zeitraum. Unser Tool zeigt, wie sich die Ansteckungen,
              Hospitalisierungen und Todesfälle entwickelt haben.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment' style={{ paddingBottom: '0' }}>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              Yannick Wiget, Sebastian Broschinski, Oliver Zihlmann, Marc
              Brupbacher
            </div>
            <div className='ta updated'>Aktualisiert am 3. Dezember 2021</div>
          </div>

          <div className='ta text'>
            <p>
              Jetzt ist es soweit: Die Corona-Pandemie hat in der Schweiz einen
              neuen Höhepunkt erreicht. Mittlerweile stecken sich im Schnitt
              {' ' + textValues.current7DayAveCases + ' '}Menschen pro Tag mit
              dem Virus an. Das sind mehr als auf dem Peak der schlimmen zweiten
              Welle im November letzten Jahres. Trotzdem gibt es weniger
              Hospitalisierungen. Das zeigt unser interaktives Tool, bei dem Sie
              jeden beliebigen Zeitraum vergleichen können:
            </p>
          </div>
        </div>
      </div> */}
      <div className='ui vertical segment' style={{ paddingBottom: '0' }}>
        {drawData && <TimeCompare preselectedCanton={props.properties?.selectedCanton} isMobile={isMobile} drawData={drawData} />}
      </div>

      {/* <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Im Vergleich zum Höhepunkt der zweiten Welle am 2. November 2020
              werden heute{' ' + textValues.changeTo2Nov2020Cases + ' '}Prozent
              {textValues.changeTo2Nov2020Cases > 0 ? ' mehr' : ' weniger'}{' '}
              Fälle gemeldet. Gleichzeitig ist die Zahl der Spitaleintritte und
              Todesfälle aber tiefer. Denn eine Mehrheit der Erwachsenen in der
              Schweiz ist inzwischen geimpft, und die Impfung schützt effektiv
              vor schweren Covid-Verläufen, wie sich hier zeigt.
            </p>
            <p>
              Auch beim Vergleich mit der dritten und vierten Welle, die ihren
              Peak am 12. April und 8. September 2021 hatten, offenbart sich der
              Impfeffekt. Aktuell müssen zwar mehr Infizierte hospitalisiert
              werden als damals. Wäre die Steigerung aber so hoch wie bei den
              Neuinfektionen, wären die Spitäler noch viel stärker belastet.
              Derzeit werden nur{' ' + textValues.currentHospRatio + ' '}
              Prozent der Erkrankten hospitalisiert und damit dreimal weniger
              als noch im April, als erst wenige geimpft waren.
            </p>
            <p>
              <DataWrapperChart chartId='SrUyq' lazy />
            </p>
            <p>
              Im Gegensatz zur zweiten Welle würden den Spitälern dieses Mal
              nicht die Hochbetagten Sorge bereiten, sondern die Jüngeren.
              Ersteren könne man meist schon in der Normalstation sehr gut
              helfen, weil sie fast alle geimpft seien, erklärt Huldrych
              Günthard, Leitender Arzt an der Infektiologie am Unispital Zürich.
              «Ältere Patienten müssen bei uns praktisch nicht mehr auf die
              Intensivstation. Daran sieht man, wie sehr die Impfung gegen die
              Überlastung der Spitäler hilft», sagt Günthard.
            </p>
            <p>
              Doch die Erfolge bei den Älteren nützen in der nun fünften Welle
              wenig. Denn nun müssen zunehmend ungeimpfte Jüngere in die
              Covid-Stationen der Spitäler in der ganzen Schweiz eingeliefert
              werden. «Die aktuell hospitalisierten Patienten sind zwischen 35
              und 65 Jahre alt», sagt Philipp Lutz, Sprecher des Kantonsspitals
              St. Gallen. Und er fügt an: «Die meisten sind nicht geimpft.» Ein
              ähnliches Bild herrscht am Berner Inselspital, wo die Patientinnen
              laut der Medienstelle mehrheitlich 40- bis 60-jährig sind und
              nicht immunisiert. An anderen Standorten gibt es gar ungeimpfte
              Patienten unter 35.
            </p>
            <p>
              «Anders als die geimpften Betagten kommen die jungen Ungeimpften
              oft so spät, dass wir ihnen auf der Normalstation nicht mehr
              helfen können», sagt Günthard. «Viele müssen sogar direkt aus der
              Notfallstation in die Intensivstation.»
            </p>
            <p>
              Und die Befürchtung ist, dass ihre Zahl in den kommenden Wochen
              weiter steigen wird. Denn bis jetzt war es immer so, dass sich die
              Lage in den Spitälern erst mit einer gewissen Verzögerung
              zuspitzte. Das sieht man gut bei der Entwicklung der zweiten
              Welle: Als die Kurve der Ansteckungen schon wieder abflachte,
              blieben die Hospitalisierungen noch länger hoch, und die Belegung
              der Intensivstationen und die Zahl der Todesfälle stiegen sogar
              noch.
            </p>

            <Quote author='Huldrych Günthard, Infektiologe am Unispital Zürich'>
              «Die Dynamik ist unaufhaltsam.»
            </Quote>

            <p>
              Was droht also der Schweiz, wenn sich die aktuelle Entwicklung
              fortsetzt? «Vielleicht reduziert sich das Verhältnis zwischen
              Neuinfektionen und Hospitalisierungen etwas. Aber die
              Hospitalisationen werden sicher ähnlich ansteigen wie vor einem
              Jahr», sagt Christian Althaus, Epidemiologe der Universität Bern.
              Auch die wissenschaftliche Taskforce des Bundes{' '}
              <Link href='915510748573' allowWordWrap>
                warnt davor
              </Link>
              , dass die Belastung in den nächsten Wochen weiter steigen wird.
            </p>
            <p>
              Althaus glaubt, dass der Trend solange anhalten wird, bis die
              Leute entweder von sich aus vorsichtiger werden und ihre Kontakte
              reduzieren oder neue Massnahmen eingeführt werden. Einige Kantone
              haben bereits Verschärfungen beschlossen, etwa eine Ausweitung der
              Maskenpflicht. Der Bundesrat hat lange gezögert und{' '}
              <Link href='594905208956' allowWordWrap>
                will jetzt wieder handeln
              </Link>
              . Aber kommt das nicht zu spät? Infektiologe Günthard rechnet
              jedenfalls mit einer massiven Spitalbelastung spätestens in der
              zweiten Dezemberwoche: «Die Dynamik ist unaufhaltsam, obwohl wir
              mit der Impfung ein Mittel gehabt hätten, das weitgehend
              aufzuhalten. Das ist einfach ernüchternd.»
            </p>
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default MainComponent
const Quote = ({ children, author }: { children: string; author: string }) => {
  return (
    <blockquote>
      <p>{children}</p>
      <span>{author}</span>
    </blockquote>
  )
}
